import axiosInstance from "@/plugins/axios"

import { defineStore } from "pinia"
import Swal from "sweetalert2"

export const useScanCodeStore = defineStore("scancode", {
  state: () => ({
    ScanCode: [],
    IncinerationScanCode: [],
    Collection: [],
    incineration: [],
    exelLink: "",
    pagination: {
      total: 0,
      current_page: 0,
      link: [],
      first_page_url: "",
      last_page: "",
    },
    pagination2: {
      total: 0,
      current_page: 0,
      link: [],
      first_page_url: "",
      last_page: "",
    },
  }),
  getters: {
    getScancode(state) {
      return state.ScanCode
    },
    getCollections(state) {
      return state.Collection
    },
    getpagniation(state) {
      return state.pagination
    },
    getincinerations(state) {
      return state.incineration
    },
    getIncineration(state) {
      return state.IncinerationScanCode
    },
  },
  actions: {
    async getCollection(pagno, show, search) {
      try {
        const response = await axiosInstance.get(
          `/collections/${show || 10}/${search || ""}?page=${pagno || 1}`
        )
        this.Collection = response.data.data.data
        this.pagination.total = response.data.data.total
        this.pagination.current_page = response.data.data.current_page
        this.pagination.link = response.data.data.links
        this.pagination.first_page_url = response.data.data.first_page_url
        this.pagination.last_page = response.data.data.last_page
      } catch (error) {
        console.error(error)
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    async getincineration(pagno, show) {
      try {
        const response = await axiosInstance.get(
          `/incinerations/${show || 10}?page=${pagno || 1}`
        )
        this.incineration = response.data.data.data
        this.pagination2.total = response.data.data.total
        this.pagination2.current_page = response.data.data.current_page
        this.pagination2.link = response.data.data.links
        this.pagination2.first_page_url = response.data.data.first_page_url
        this.pagination2.last_page = response.data.data.last_page
      } catch (error) {
        console.error(error)
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    // collection pdf and excel export
    async getExcelpdf(requestBody) {
      try {
        // Show SweetAlert with a loading spinner
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/collections/export/pdf",
            requestBody
          )
          // Check if the status code is 200
          if (response.status === 200) {
            // Open the file link in a new tab
            window.open(response.data.data.link, "_blank")
          } else {
            // Handle unexpected status codes
            throw new Error("Unexpected status code: " + response.status)
          }
        } else {
          console.log("Export canceled by user")
        }
      } catch (error) {
        console.error(error)

        // Close loading spinner in case of an error
        Swal.close()

        // Show SweetAlert with the error message
        Swal.fire({
          icon: "error",
          title: "Export Error",
          text:
            error?.response?.data?.message ||
            "An error occurred while exporting data.",
        })

        // Rethrow the error to handle it in the calling code if needed
        throw error
      }
    },
    async getExcelExcel(requestBody) {
      try {
        // Show SweetAlert confirmation with a loading spinner
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })

        // Check if the user clicked "Ok"
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/collections/export/excel",
            requestBody
          )

          // Check if the status code is 200
          if (response.status === 200) {
            // Open the file link in a new tab
            window.open(response.data.data.link, "_blank")
          } else {
            // Handle unexpected status codes
            throw new Error("Unexpected status code: " + response.status)
          }
        } else {
          console.log("Export canceled by user")
        }
      } catch (error) {
        console.error(error)

        // Close loading spinner in case of an error
        Swal.close()

        // Show SweetAlert with the error message
        Swal.fire({
          icon: "error",
          title: "Export Error",
          text:
            error?.response?.data?.message ||
            "An error occurred while exporting data.",
        })

        // Rethrow the error to handle it in the calling code if needed
        throw error
      }
    },

    //Incineration
    async getExcelExcelinceneration(requestBody) {
      try {
        // Show SweetAlert with a loading spinner
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/incinerations/export/excel",
            requestBody
          )
          // Check if the status code is 200
          if (response.status === 200) {
            // Open the file link in a new tab
            window.open(response.data.data.link, "_blank")
          } else {
            // Handle unexpected status codes
            throw new Error("Unexpected status code: " + response.status)
          }
        } else {
          console.log("Export canceled by user")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Export Error",
          text:
            error?.response?.data?.message ||
            "An error occurred while exporting data.",
        })

        // Rethrow the error to handle it in the calling code if needed
        throw error
      }
    },

    async getExcelpdfinceneration(requestBody) {
      try {
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/incinerations/export/pdf",
            requestBody
          )
          // Check if the status code is 200
          if (response.status === 200) {
            // Open the file link in a new tab
            window.open(response.data.data.link, "_blank")
          } else {
            // Handle unexpected status codes
            throw new Error("Unexpected status code: " + response.status)
          }
        } else {
          console.log("Export canceled by user")
        }
      } catch (error) {
        console.error(error)

        // Close loading spinner in case of an error
        Swal.close()

        // Show SweetAlert with the error message
        Swal.fire({
          icon: "error",
          title: "Export Error",
          text:
            error?.response?.data?.message ||
            "An error occurred while exporting data.",
        })

        // Rethrow the error to handle it in the calling code if needed
        throw error
      }
    },

    //24 hour report
    async getExcelExceldaterangereport(requestBody) {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/twenty-four-hours-progress",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },


    async getExcelExcelGenerateDisposalPerformanceReport(requestBody) {
      try {
        // Show SweetAlert with a loading spinner
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/incinerator-performance",
            requestBody
          )
          // Check if the status code is 200
          if (response.status === 200) {
            // Open the file link in a new tab
            window.open(response.data.data.link, "_blank")
          } else {
            // Handle unexpected status codes
            throw new Error("Unexpected status code: " + response.status)
          }
        } else {
          console.log("Export canceled by user")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Export Error",
          text:
            error?.response?.data?.message ||
            "An error occurred while exporting data.",
        })

        // Rethrow the error to handle it in the calling code if needed
        throw error
      }
    },


    //Date Wise Report excel
    async getExcelExceldaterangereports(requestBody) {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/date-range",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    async getExcelExceldaterangereports2(requestBody) {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/infectious-waste-monitoring-report",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    //tehsil pdf
    async getExcelExcelTehsil() {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.get("/tehsils/export")
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    async getExcelExcelHospital() {
      try {
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.get("/hospitals/export")
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    async getExcelExcelDailyRoaster() {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.get("/daily-roaster/export")
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    async getExcelStaff() {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.get("/staffs/export")
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },
    async getExcelExcelUser() {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.get("/users/export")
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    //report excel

    async getExcelExcelQuaterlyReport(requestBody) {
      try {
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/quarterly",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    async getExcelExcelQuaterlyweeklyReport(requestBody) {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/weekly",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    async getExcelExcelQuaterlyMonthlyReport(requestBody) {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/monthly",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },

    async getExcelExcelQuaterlyYearlyReport(requestBody) {
      try {
        // Show loading spinner while waiting for the response
        const confirmation = await Swal.fire({
          title: "Export Data",
          text: "Heads up! Exporting may take some time. ",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ok!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        if (confirmation.isConfirmed) {
          const response = await axiosInstance.post(
            "/excel-report/yearly",
            requestBody
          )
          this.excelLink = response.data.data.link
          // loadingAlert.close()
          window.open(this.excelLink, "_blank")
        }
      } catch (error) {
        console.error(error)
        Swal.close()
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while exporting data.",
        })
        throw error // Rethrow the error to handle it in the calling code
      }
    },
  },
})
